export const rawDigits = (input) => (input || '').replace(/\D/g, '');
export const hasUSCountryCode = (input) => rawDigits(input).substr(0, 1) === '1';

export const extractDigits = (input) => {
  const digitsOnly = rawDigits(input);
  if (digitsOnly[0] === '1') {
    return digitsOnly.substr(1);
  }
  return digitsOnly;
};

export const formatPhoneNumber = (input, def) => {
  if (!input) {
    return def || '';
  }
  const digitsOnly = extractDigits(input);
  const hasOne = hasUSCountryCode(input);
  return digitsOnly.replace(/(\d{3})(\d{3})(\d{4})/, `${hasOne ? '+1' : ''} ($1) $2-$3`);
};

export const cognitoPhoneNumber = (input) => {
  if (!input) {
    return '';
  }
  const digitsOnly = extractDigits(input);
  if (digitsOnly[0] === '1') {
    return `+${digitsOnly}`;
  }
  return `+1${digitsOnly}`;
};
